import React, { useEffect, useRef, useState } from "react";
import { useResultTable } from "../../../services/ResultTableProvider";

interface Props {
  afterShootnr: number;
  ipos: number | null | undefined;
}

const ResultTableHeader = ({ afterShootnr, ipos }: Props) => {
  const refHead = useRef<HTMLDivElement>(null);
  const {setWidthRow} = useResultTable();

  useEffect(() => {
    const updateWidth = () => {
      let refRes: HTMLDivElement | null = refHead.current;
      if (refRes){
        setWidthRow(refRes.offsetWidth);
      }
      // const currentTopRowWidth = topRowRef.current?.offsetWidth || 0;
      // if (currentTopRowWidth > topRowMaxWidth) {
      //   // setTopRowMaxWidth(currentTopRowWidth);
      // }
    };

    const topRowElement = refHead.current;
    let resizeObserver: ResizeObserver | null = null;

    if (topRowElement) {
      resizeObserver = new ResizeObserver(updateWidth);
      resizeObserver.observe(topRowElement);
    }
    updateWidth();

    return () =>{
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  },[])

  const [hideShooting, setHideShooting] = useState<boolean>(
    afterShootnr === 0 ? false : true
  );
  return (
    <div className="result-blade-header">
      <div className="resultrowdata-inner-row-top">
        <div className="resultrowdata-inner-inner-row-top" ref={refHead}>
        <div className="resultrow" id="head_RV_0">
          <div
            id="RV_0_rank_owner"
            className="resultrowdata resultrowrank clrank"
            data-rank-owner="RV_0"
          >
            <span id="RV_0_rank" data-trans="rank">
              {ipos === 0 ? "Fav" : "Rn."}
            </span>
          </div>
          <div className="resultrowdata resultrowrank-bib clrank-clbib">
            <span>R/B</span>
          </div>
          <div className="resultrowdata resultrowbib clbib">
            <span id="RV_0_bib" data-trans="bib">
              Bib
            </span>
          </div>
          <div className="resultrowdata resultrowshortname clshortname">
            <span id="RV_0_shortname" data-trans="shortname">
              Name
            </span>
          </div>
          <div className="resultrowdata resultrowname clname">
            <span id="RV_0_name" data-trans="name">
              Name
            </span>
          </div>
          <div className="resultrowdata resultrowflag clflag">
            <span id="RV_0_flag" data-trans="nation">
              Nat
            </span>
          </div>

          <div className="resultrowdata resultrowteam clteam">
            <span id="RV_0_team" data-trans="team">
              Team
            </span>
          </div>
          <div className="resultrowdata resultrowrelay clrelay">
            <span id="RV_0_relay" data-trans="relay">
              Relay
            </span>
          </div>
          <div className="resultrowdata resultrowshooting clshootingstring">
            <span id="RV_0_runtime" data-trans="shooting">
              Shooting
            </span>
          </div>
          <div
            className="resultrowdata resultrowshooting clshooting"
            style={
              afterShootnr === 0
                ? { display: "none" }
                : { display: "table-cell" }
            }
          >
            <span id="RV_0_runtime" data-trans="shooting">
              Sht
            </span>
          </div>
          <div className="resultrowdata resultrowruntime clruntime">
            <span id="RV_0_runtime" data-trans="runtime">
              Time
            </span>
          </div>
          <div className="resultrowdata resultrowdiff cldifftime">
            <span id="RV_0_difftime" data-trans="difftime">
              {ipos === 0 ? "RTim" : "Diff"}
            </span>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ResultTableHeader;
